module.exports = __webpack_public_path__ + "img/photo_paul.73fb51f4.png";